import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import {
  NotificationService,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_INFO,
} from 'ui-components/services/notification-service';
import Global from '../../../store/global-selectors';
import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import { FulfillmentContext } from '../context';

import { retryNotificationsPromise } from '../../../store/send-notifications/send-notifications.api';

import { testId } from 'ui-components/services/testid-service';

const messages = defineMessages({
  notifyMarketplace: {
    defaultMessage: 'Notify Marketplace',
    id: 'LkAgD/',
    description: 'gridHeader.notifyMarketplace',
  },
  notifyingTitle: {
    description: 'starting notify marketplace processing title',
    defaultMessage: 'Processing...',
    id: 'ahKp1x',
  },
  notifyingContent: {
    description: 'starting notify marketplace processing content',
    defaultMessage: 'Notifying Marketplace',
    id: 'FKoBQN',
  },
  marketplaceNotificationSuccessTitle: {
    description: 'sendingmarketplaceNotificationContent.marketplaceNotificationSuccessTitle',
    defaultMessage: 'Processed',
    id: 'ATyQMS',
  },
  marketplaceNotificationSuccessContent: {
    description: 'sendingmarketplaceNotificationContent.marketplaceNotificationSuccessContent',
    defaultMessage: 'Marketplace Notification Sent!',
    id: 'z0SFUE',
  },
  marketplaceNotificationErrorTitle: {
    description: 'sendingmarketplaceNotificationContent.marketplaceNotificationErrorTitle',
    defaultMessage: 'Error',
    id: 'iy7qDI',
  },
  marketplaceNotificationErrorContent: {
    description: 'sendingmarketplaceNotificationContent.marketplaceNotificationErrorContent',
    defaultMessage: 'Marketplace Notification Failed',
    id: '7X3uD5',
  },
});

export const NotifyMarketplaceButton = () => {
  const { selectedFulfillmentIds, refreshGridData } = useContext(FulfillmentContext);
  const selectedFulfillmentPlanIds = useSelector((state) =>
    Global.selectEntitiesFPIdsByFulfillmentIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );

  const oneOrMoreShipmentSelected = selectedFulfillmentPlanIds.length > 0;
  const disabled = !oneOrMoreShipmentSelected;

  const notifyMarketplace = useCallback(() => {
    NotificationService.showNotification({
      title: <FormattedMessage {...messages.notifyingTitle} />,
      notificationType: NOTIFICATION_TYPE_INFO,
      content: <FormattedMessage {...messages.notifyingContent} />,
      duration: 3000,
    });

    // yes this is the same action as send-notifications. The BE both sends notifications and notifies marketplaces.
    retryNotificationsPromise(selectedFulfillmentPlanIds)
      .then(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...messages.marketplaceNotificationSuccessTitle} />,
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          content: <FormattedMessage {...messages.marketplaceNotificationSuccessContent} />,
          duration: 3000,
        });
        refreshGridData();
      })
      .catch(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...messages.marketplaceNotificationErrorTitle} />,
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.marketplaceNotificationErrorContent} />,
          duration: 3000,
        });
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFulfillmentPlanIds]);

  return (
    <ReuseableGridButton
      {...testId('fulfillments-notify-marketplace-button')}
      actionHandler={notifyMarketplace}
      disable={disabled}
      messageDescriptor={messages.notifyMarketplace}
      theme='tertiary'
    />
  );
};
